import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppHeader from "./components/AppHeader";
import AppFooter from "./components/AppFooter";

const DiscoverPage = lazy(() => import("./pages/DiscoverPage"));
const GamePage = lazy(() => import("./pages/GamePage"));
const CreatePage = lazy(() => import("./pages/CreatePage"));
const LeaderboardsPage = lazy(() => import("./pages/LeaderboardsPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const RecoverPage = lazy(() => import("./pages/RecoverPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

function RouteLoader() {
  return <main className="route-loader" aria-live="polite"><span className="loader-grid" aria-hidden="true" />Loading puzzle pieces…</main>;
}

export default function App() {
  return (
    <div className="app-shell">
      <AppHeader />
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          <Route path="/" element={<DiscoverPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/p/:slug" element={<GamePage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/p/:slug/edit" element={<CreatePage />} />
          <Route path="/leaderboards" element={<LeaderboardsPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/recover" element={<RecoverPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/play" element={<Navigate to="/p/ocean-wonders" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      <AppFooter />
    </div>
  );
}
